/* This file is automatically generated, do not edit manually! */

/* eslint-disable */

exports.KDDI_INDEX = {

  '@CA': 
  [
     'CA11',
     'CA12',
     'CA13',
     'CA14',
     'CA21',
     'CA22',
     'CA23',
     'CA24',
     'CA25',
     'CA26',
     'CA27',
     'CA28',
     'CA31',
     'CA32',
     'CA33',
     'CA34',
     'CA35',
     'CA36',
     'CA37',
     'CA38',
     'CA39',
     'CA3A',
     'CA3B',
     'CA3C',
     'CA3D',
     'CA3E',
     'CA3F',
     'CA3G',
     'CA3H',
     'CA3I',
     'CA3J',
     'CA3K',
  ],
  '@DN': 
  [
     'DN01',
     'DN11',
  ],
  '@ER': 
  [
     'ERK0',
  ],
  '@FJ': 
  [
     'FJ31',
  ],
  '@HI': 
  [
     'HI01',
     'HI02',
     'HI11',
     'HI12',
     'HI13',
     'HI14',
     'HI21',
     'HI23',
     'HI24',
     'HI31',
     'HI32',
     'HI33',
     'HI34',
     'HI35',
     'HI36',
     'HI37',
     'HI38',
     'HI39',
     'HI3A',
     'HI3B',
     'HI3C',
     'HI3D',
     'HI3E',
     'HI3F',
     'HI3G',
     'HI3H',
  ],
  '@KC': 
  [
     'KC3Q',
     'KC3S',
     'KC3V',
     'KC11',
     'KC12',
     'KC13',
     'KC14',
     'KC15',
     'KC21',
     'KC22',
     'KC23',
     'KC24',
     'KC25',
     'KC26',
     'KC27',
     'KC28',
     'KC29',
     'KC2A',
     'KC31',
     'KC32',
     'KC33',
     'KC34',
     'KC35',
     'KC36',
     'KC37',
     'KC38',
     'KC39',
     'KC3A',
     'KC3B',
     'KC3D',
     'KC3E',
     'KC3G',
     'KC3H',
     'KC3I',
     'KC3K',
     'KC3M',
     'KC3N',
     'KC3O',
     'KC3P',
     'KC3R',
     'KC3T',
     'KC3U',
     'KC3W',
     'KC3X',
     'KC3Y',
     'KC3Z',
     'KC41',
     'KC42',
     'KC43',
     'KC44',
     'KC45',
     'KC46',
     'KC47',
     'KC48',
     'KC4A',
     'KCC1',
     'KCC2',
     'KCI1',
     'KCI2',
     'KCT1',
     'KCT2',
     'KCT3',
     'KCT4',
     'KCT5',
     'KCT6',
     'KCT7',
     'KCT8',
     'KCT9',
     'KCTA',
     'KCTB',
     'KCTC',
  ],
  '@MA': 
  [
     'MA11',
     'MA12',
     'MA13',
     'MA21',
     'MA31',
     'MA32',
     'MA33',
     'MA34',
     'MA35',
     'MAC1',
     'MAC2',
     'MAI1',
     'MAI2',
     'MAT1',
     'MAT2',
     'MAT3',
  ],
  '@MI': 
  [
     'MIT1',
  ],
  '@PT': 
  [
     'PT21',
     'PT23',
     'PT33',
     'PT34',
     'PT35',
     'PT36',
  ],
  '@SA': 
  [
     'SA21',
     'SA22',
     'SA24',
     'SA25',
     'SA26',
     'SA27',
     'SA28',
     'SA29',
     'SA2A',
     'SA31',
     'SA32',
     'SA33',
     'SA34',
     'SA35',
     'SA36',
     'SA37',
     'SA38',
     'SA39',
     'SA3A',
     'SA3B',
     'SA3C',
     'SA3D',
     'SA3E',
  ],
  '@SH': 
  [
     'SH31',
     'SH32',
     'SH33',
     'SH34',
     'SH35',
     'SH36',
     'SH37',
     'SH38',
     'SH39',
     'SH3A',
     'SH3B',
     'SH3C',
     'SH3D',
     'SH3E',
     'SH3F',
     'SH3G',
     'SH3H',
     'SH3I',
     'SH3J',
     'SH3K',
     'SH3L',
  ],
  '@SN': 
  [
     'SN3K',
     'SN3T',
     'SN11',
     'SN13',
     'SN14',
     'SN15',
     'SN16',
     'SN17',
     'SN21',
     'SN22',
     'SN23',
     'SN24',
     'SN25',
     'SN26',
     'SN27',
     'SN28',
     'SN29',
     'SN31',
     'SN32',
     'SN33',
     'SN34',
     'SN35',
     'SN36',
     'SN37',
     'SN38',
     'SN39',
     'SN3A',
     'SN3B',
     'SN3C',
     'SN3D',
     'SN3E',
     'SN3F',
     'SN3G',
     'SN3H',
     'SN3I',
     'SN3J',
     'SN3L',
     'SN3M',
     'SN3N',
     'SN3O',
     'SN3P',
     'SN3Q',
     'SN3R',
     'SN3S',
     'SN3U',
     'SN3V',
  ],
  '@ST': 
  [
     'ST22',
     'ST33',
     'ST11',
     'ST12',
     'ST13',
     'ST14',
     'ST21',
     'ST23',
     'ST24',
     'ST25',
     'ST26',
     'ST27',
     'ST28',
     'ST29',
     'ST2A',
     'ST2C',
     'ST2D',
     'ST31',
     'ST32',
     'ST34',
  ],
  '@SY': 
  [
     'SY12',
     'SY13',
     'SY14',
     'SY15',
     'SYC1',
     'SYT1',
     'SYT2',
     'SYT3',
     'SYT4',
     'SY01',
     'SY02',
     'SY03',
     'SY11',
  ],
  '@TS': 
  [
     'TS3Q',
     'TS3U',
     'TS3W',
     'TS01',
     'TS11',
     'TS12',
     'TS13',
     'TS14',
     'TS21',
     'TS22',
     'TS23',
     'TS24',
     'TS25',
     'TS26',
     'TS27',
     'TS28',
     'TS29',
     'TS2A',
     'TS2B',
     'TS2C',
     'TS2D',
     'TS2E',
     'TS31',
     'TS32',
     'TS33',
     'TS34',
     'TS35',
     'TS36',
     'TS37',
     'TS38',
     'TS39',
     'TS3A',
     'TS3B',
     'TS3C',
     'TS3D',
     'TS3E',
     'TS3G',
     'TS3H',
     'TS3I',
     'TS3J',
     'TS3K',
     'TS3L',
     'TS3M',
     'TS3N',
     'TS3O',
     'TS3P',
     'TS3R',
     'TS3S',
     'TS3T',
     'TS3V',
     'TS3X',
     'TS3Y',
     'TS3Z',
     'TS41',
     'TSC1',
     'TSI1',
     'TST1',
     'TST2',
     'TST3',
     'TST4',
     'TST5',
     'TST6',
     'TST7',
  ],
};

/* This file is automatically generated, do not edit manually! */
